var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgClaimsSearch = function SvgClaimsSearch(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.041 146H12L35.0612 26H152L129.041 146Z",
    fill: "#E6E6F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132 129.5H15L14 135.5H131L132 129.5Z",
    fill: "#9FA4D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 128.5C8 127.672 8.67157 127 9.5 127H136.5C137.328 127 138 127.672 138 128.5C138 129.328 137.328 130 136.5 130H9.5C8.67157 130 8 129.328 8 128.5Z",
    fill: "#313E48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M124.015 105.087H22.9897C19.6954 105.087 17 102.437 17 99.198V26.073C17 22.8339 19.6954 20.1837 22.9897 20.1837H124.015C127.31 20.1837 130.005 22.8339 130.005 26.073V99.198C130.005 102.437 127.31 105.087 124.015 105.087Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9897 21.6837C20.4998 21.6837 18.5 23.6861 18.5 26.073V99.198C18.5 101.585 20.4998 103.587 22.9897 103.587H124.015C126.505 103.587 128.505 101.585 128.505 99.198V26.073C128.505 23.6861 126.505 21.6837 124.015 21.6837H22.9897ZM15.5 26.073C15.5 21.9817 18.8909 18.6837 22.9897 18.6837H124.015C128.114 18.6837 131.505 21.9817 131.505 26.073V99.198C131.505 103.289 128.114 106.587 124.015 106.587H22.9897C18.8909 106.587 15.5 103.289 15.5 99.198V26.073Z",
    fill: "#313E48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.583 29.1862H121.223V97.1644H25.583V29.1862ZM28.583 32.1862V94.1644H118.223V32.1862H28.583Z",
    fill: "#313E48"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.8827 120.694V104.989H62.0222V120.694H53.2373V128.055H93.6676V120.694H84.8827Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5222 103.489H86.3827V119.194H95.1676V129.555H51.7373V119.194H60.5222V103.489ZM63.5222 106.489V122.194H54.7373V126.555H92.1676V122.194H83.3827V106.489H63.5222Z",
    fill: "#313E48"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6682 88.6955H51.2414C50.1433 88.6955 49.2448 87.8121 49.2448 86.7324L47.1484 24.797H83.1863C88.9763 24.797 93.7681 29.4102 93.7681 35.2013L95.8644 86.6342C95.7646 87.7139 94.8662 88.6955 93.6682 88.6955Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5967 23.297H83.1862C89.7609 23.297 95.2505 28.5323 95.2679 35.1697L97.3671 86.6729L97.3579 86.7723C97.1963 88.5201 95.7407 90.1955 93.6681 90.1955H51.2413C49.3482 90.1955 47.7606 88.6796 47.7448 86.7613L45.5967 23.297ZM48.6999 26.297L50.7447 86.707V86.7324C50.7447 86.9598 50.9476 87.1955 51.2413 87.1955H93.6681C93.8394 87.1955 93.9946 87.1296 94.1263 87.0001C94.2482 86.8803 94.33 86.7232 94.3604 86.5677L92.2679 35.2319V35.2013C92.2679 30.2716 88.1811 26.297 83.1862 26.297H48.6999Z",
    fill: "#313E48"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1859 47.7928H57.1309V44.7928H83.1859V47.7928Z",
    fill: "#313E48"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1859 54.9581H57.1309V51.9581H83.1859V54.9581Z",
    fill: "#313E48"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.1859 62.1233H57.1309V59.1233H83.1859V62.1233Z",
    fill: "#313E48"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1893 77.0151H38.7624C37.6643 77.0151 36.666 76.1317 36.666 74.9539V16.0612C36.666 14.9815 37.5645 14 38.7624 14H72.7039C78.4939 14 83.2856 18.6133 83.2856 24.4044V75.052C83.1858 76.1317 82.2874 77.0151 81.1893 77.0151Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.7624 15.5C38.4153 15.5 38.166 15.7874 38.166 16.0612V74.9539C38.166 75.1017 38.2244 75.2329 38.3364 75.3395C38.4557 75.453 38.6137 75.5151 38.7624 75.5151H81.1893C81.4446 75.5151 81.7305 75.2998 81.7856 74.9637V24.4044C81.7856 19.4746 77.6988 15.5 72.7039 15.5H38.7624ZM35.166 16.0612C35.166 14.1757 36.7137 12.5 38.7624 12.5H72.7039C79.289 12.5 84.7856 17.7519 84.7856 24.4044V75.1212L84.7793 75.1901C84.6133 76.985 83.1177 78.5151 81.1893 78.5151H38.7624C36.907 78.5151 35.166 77.0295 35.166 74.9539V16.0612Z",
    fill: "#313E48"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.186 25.0914H72.7041V14C72.7041 14 83.6852 15.3742 83.186 25.0914Z",
    fill: "#EADB9E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8904 12.5116L72.7041 14C72.8904 12.5116 72.891 12.5117 72.8918 12.5118L72.8934 12.512L72.8975 12.5125L72.9087 12.514L72.9429 12.5186C72.9708 12.5225 73.0091 12.5281 73.0569 12.5355C73.1525 12.5503 73.2865 12.5726 73.4535 12.6041C73.787 12.6671 74.2541 12.7676 74.8094 12.9201C75.9137 13.2235 77.4001 13.7419 78.8856 14.6047C81.8962 16.3532 84.9708 19.5864 84.6841 25.1684C84.6431 25.9659 83.9846 26.5915 83.186 26.5915H72.7041C71.8757 26.5915 71.2041 25.9199 71.2041 25.0915V14C71.2041 13.5697 71.3889 13.1602 71.7115 12.8754C72.0341 12.5907 72.4634 12.4582 72.8904 12.5116ZM74.2041 15.8663V23.5915H81.6645C81.3732 20.3332 79.4489 18.4011 77.3789 17.1988C76.2604 16.5492 75.1156 16.1291 74.2041 15.8663Z",
    fill: "#313E48"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8041 36.9958H46.749V33.9958H72.8041V36.9958Z",
    fill: "#313E48"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8041 44.1611H46.749V41.1611H72.8041V44.1611Z",
    fill: "#313E48"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.8041 51.3264H46.749V48.3264H72.8041V51.3264Z",
    fill: "#313E48"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M71.406 59.8381H47.4473V66.5126H71.406V59.8381Z",
    fill: "#EADB9E"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.9473 58.3381H72.906V68.0126H45.9473V58.3381ZM48.9473 61.3381V65.0126H69.906V61.3381H48.9473Z",
    fill: "#313E48"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M83.8849 81.7265C95.7386 81.7265 105.348 72.2783 105.348 60.6233C105.348 48.9684 95.7386 39.5201 83.8849 39.5201C72.0312 39.5201 62.4219 48.9684 62.4219 60.6233C62.4219 72.2783 72.0312 81.7265 83.8849 81.7265Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.785 41.3146C72.7909 41.3146 63.9219 50.0711 63.9219 60.8196C63.9219 71.5682 72.7909 80.3247 83.785 80.3247C94.7792 80.3247 103.648 71.5682 103.648 60.8196C103.648 50.0711 94.7792 41.3146 83.785 41.3146ZM60.9219 60.8196C60.9219 48.3666 71.1821 38.3146 83.785 38.3146C96.388 38.3146 106.648 48.3666 106.648 60.8196C106.648 73.2726 96.388 83.3247 83.785 83.3247C71.1821 83.3247 60.9219 73.2726 60.9219 60.8196Z",
    fill: "#313E48"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.6925 75.0758C99.2756 74.4874 100.225 74.4832 100.814 75.0664L113.192 87.3357C113.781 87.9188 113.785 88.8686 113.202 89.457C112.619 90.0453 111.669 90.0496 111.081 89.4664L98.7019 77.1971C98.1135 76.6139 98.1093 75.6641 98.6925 75.0758Z",
    fill: "#313E48"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5644 53.3599H72.4043V58.5621H95.5644V53.3599Z",
    fill: "#CFD9E1"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9043 51.8599H97.0644V60.0621H70.9043V51.8599ZM73.9043 54.8599V57.0621H94.0644V54.8599H73.9043Z",
    fill: "#313E48"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5644 64.1569H72.4043V69.3591H95.5644V64.1569Z",
    fill: "#94C1AE"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.9043 62.6569H97.0644V70.8591H70.9043V62.6569ZM73.9043 65.6569V67.8591H94.0644V65.6569H73.9043Z",
    fill: "#313E48"
  })));
};
export { SvgClaimsSearch as ReactComponent };
export default __webpack_public_path__ + "static/media/claims-search.7b286e6b.svg";